import {
  Card,
  CardContent,
  Checkbox,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { HoldTypeFormStore } from '../stores/HoldTypeFormStore'

import { RoleOption } from '../HoldTypesPage'

interface Props {
  formStore: HoldTypeFormStore
  userRoleOptions?: RoleOption[]
}

export const HoldTypeBasicInfoCard = observer(({ formStore, userRoleOptions = [] }: Props) => {
  const { t } = useTranslate()

  const selectedRoles = formStore.userRoles.value

  return (
    <Card>
      <CardContent>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              value={formStore.type.value}
              onChange={formStore.type.onChange}
              onBlur={formStore.type.touch}
              error={!!formStore.type.error}
              helperText={formStore.type.error ? t(formStore.type.error) : ''}
              label={t('type', 'Type')}
              fullWidth
              required
            />
          </Grid>

          <Grid size={12}>
            <FormControl fullWidth>
              <InputLabel>{t('userRoles', 'User roles')}</InputLabel>
              <Select
                multiple
                value={selectedRoles}
                onChange={e => formStore.userRoles.setValue(e.target.value as number[])}
                onBlur={formStore.userRoles.touch}
                input={<OutlinedInput label={t('userRoles', 'User roles')} />}
                renderValue={selected =>
                  (selected as number[]).map(v => {
                    const label = userRoleOptions.find(o => o.value === v)?.label ?? String(v)
                    return <Chip key={v} label={label} size='small' sx={{ mr: 0.5 }} />
                  })
                }
              >
                {userRoleOptions.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    <Checkbox checked={selectedRoles.includes(option.value)} />
                    <ListItemText primary={option.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid size={12}>
            <TextField
              value={formStore.description.value}
              onChange={formStore.description.onChange}
              onBlur={formStore.description.touch}
              error={!!formStore.description.error}
              helperText={
                formStore.description.error
                  ? t(formStore.description.error, 'Field is required.')
                  : ''
              }
              label={t('description', 'Description')}
              fullWidth
              multiline
              minRows={3}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
})
